// extracted by mini-css-extract-plugin
module.exports = {"loader":"hF5qY","loading":"_38rja","spinner":"_2xNzD","rotation":"tTCG6"};